import React from 'react';
import { useTranslation } from 'react-i18next';

import { Col, Select } from '../styles/ExpenseSummaryStyle';

const ExpenseSummaryYearSelector = ({ viewMode, yearLists, selectedYear, handleChangeYear }) => {
  const { t } = useTranslation();

  return (
    <Col>
      {viewMode === 'Yearly' && (
        <>
          <label>{t('features.Dashbord.components.ExpenseSummaryYearSelector.yearly_label')}</label>
          <Select name="compareYear" onChange={handleChangeYear} value={selectedYear?.compareYear}>
            {yearLists.map(year => (
              <option key={year} disabled={year > selectedYear?.targetYear && viewMode === 'Yearly'} value={year}>
                {year}
              </option>
            ))}
          </Select>
          -
        </>
      )}
      {viewMode === 'Monthly' && <label>{t('features.Dashbord.components.ExpenseSummaryYearSelector.monthly_label')}</label>}
      <Select name="targetYear" onChange={handleChangeYear} value={selectedYear?.targetYear}>
        {yearLists.map(year => (
          <option key={year} disabled={year < selectedYear?.compareYear && viewMode === 'Yearly'} value={year}>
            {year}
          </option>
        ))}
      </Select>
    </Col>
  );
};

export default ExpenseSummaryYearSelector;
